import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

const SortArray = [
  //{ label: "Recent", value: "recent" },
  // { label: "Name A-Z", value: "asc" },
  // { label: "Name Z-A", value: "desc" },
  { label: "Featured", value: "desc" },
  { label: "High to Low", value: "asc" },
  { label: "Low to High", value: "desc" },
  { label: "A to Z", value: "asc" },
  { label: "Z to A", value: "desc" },
];

// const getSortLabel = (id) => {
//   const temp = SortArray?.filter((it) => it?.value === id);
//   return temp[0]?.label;
// };

const getSortLabel = (sortKey, sortOrder) => {
  if (sortKey === 'interest' && sortOrder === 'asc') return "High to Low";
  if (sortKey === 'interest' && sortOrder === 'desc') return "Low to High";
  if (sortKey === 'name' && sortOrder === 'asc') return "A to Z";
  if (sortKey === 'name' && sortOrder === 'desc') return "Z to A";
  if (sortKey === 'featured') return "Featured";
  return "Featured";
};

const SortBy = (props) => {
  // const [sortByVal, setSortByVal] = useState(
  //   props?.value !== null && props?.value !== undefined
  //     ? getSortLabel(props.value)
  //     : "Featured"
  // );
  const [sortByVal, setSortByVal] = useState(
  props?.value !== null && props?.value !== undefined
    ? getSortLabel(props?.sortKey, props?.value)
    : "Featured"
);

  const [sortByEl, setsortByEl] = useState(null);
  const dropdownopen = Boolean(sortByEl);
  const handleDropdownClick = (event) => {
    setsortByEl(event.currentTarget);
  };
  const handleDropdownChange = (ans) => {
    props.handleSortBy(ans);
    setSortByVal(ans);
    setsortByEl(null);
  };
  return (
    <div
      className={`select_opt relative bottom-[2px] pl-[20px] right-[20px] cursor-pointer shrink-0`}
    >
      <img
        src="/images/select_icon2.svg"
        alt="arrow"
        className="absolute top-[11px] left-[22px]"
      />
      <img
        src="/images/select_icon1.svg"
        alt="arrow"
        className="absolute top-[15px] right-[2px]"
      />
      <Button
        id="sortby-button"
        aria-controls={dropdownopen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={dropdownopen ? "true" : undefined}
        onClick={handleDropdownClick}
      >
        {sortByVal}
      </Button>
      <Menu
        id="sortby-menu"
        anchorEl={sortByEl}
        open={dropdownopen}
        onClose={() => setsortByEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        defaultValue={"Featured"}
      >
        {SortArray.map((item, idx) => {
          return (
            <MenuItem
              //key={item?.value}
              key={`${item.value}-${idx}`}
              onClick={() => handleDropdownChange(item?.label)}
            >
              {item?.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default SortBy;
